/**
 * Trợ lý pháp luật — 5 tab: Phân tích tài liệu, Soạn thảo & hiệu chỉnh, Nghiên cứu pháp lý, Cố vấn & chiến lược, Tích hợp không gian làm việc
 */
import { useState } from 'react'
import { Box, Container, Paper, Tab, Tabs, Typography } from '@mui/material'
import { DocumentAnalysisTab } from './aiResearch/DocumentAnalysisTab'
import { DraftingReviewTab } from './aiResearch/DraftingReviewTab'
import { LegalResearchTab } from './aiResearch/LegalResearchTab'
import { StrategyAdvisorTab } from './aiResearch/StrategyAdvisorTab'
import { WorkspaceIntegrationTab } from './aiResearch/WorkspaceIntegrationTab'

const TAB_KEYS = [
  'analysis',
  'drafting',
  'research',
  'strategy',
  'workspace',
] as const

const TAB_LABELS: Record<(typeof TAB_KEYS)[number], string> = {
  analysis: 'Phân tích tài liệu',
  drafting: 'Soạn thảo & hiệu chỉnh',
  research: 'Tư vấn pháp lý',
  strategy: 'Cố vấn & Red Team AI',
  workspace: 'Không gian làm việc',
}

function AIResearchPage() {
  const [tab, setTab] = useState(2)

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 112px)',
        overflow: 'hidden',
        bgcolor: 'grey.100',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          flexShrink: 0,
          borderRadius: 0,
        }}
      >
        <Container maxWidth={false} disableGutters sx={{ width: '100%', px: { xs: 2, sm: 3 }, py: { xs: 1.75, sm: 2 } }}>
          <Typography variant="h6" component="h1" fontWeight={700} color="primary.dark" sx={{ fontSize: { xs: '1.05rem', sm: '1.15rem' } }}>
            Trợ lý pháp luật
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
            Phân tích tài liệu, soạn thảo, nghiên cứu pháp lý, chiến lược và tích hợp workspace
          </Typography>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              mt: 2,
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, minHeight: 44 },
            }}
          >
            {TAB_KEYS.map((k, i) => (
              <Tab key={k} label={TAB_LABELS[k]} value={i} />
            ))}
          </Tabs>
        </Container>
      </Paper>

      <Container
        maxWidth={false}
        disableGutters
        sx={{
          width: '100%',
          px: { xs: 2, sm: 3 },
          pt: 2,
          pb: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {tab === 0 && <DocumentAnalysisTab />}
        {tab === 1 && <DraftingReviewTab />}
        {tab === 2 && <LegalResearchTab />}
        {tab === 3 && <StrategyAdvisorTab />}
        {tab === 4 && <WorkspaceIntegrationTab />}
      </Container>
    </Box>
  )
}

export default AIResearchPage
